import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Departments from './Departments';
import Jobs from './Jobs';
import Offices from './Offices';

const JobBoard = (
  {
    classes,
  },
) => (
  <div className={classes.jobBoard}>
    <div className={classes.filters}>
      <Departments />

      <Offices />
    </div>

    <div>
      <Jobs />
    </div>
  </div>
);

const mapStateToProps = state => ({
  ...state,
});

JobBoard.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default compose(
  connect(mapStateToProps),
  injectSheet({
    jobBoard: {

    },
    filters: {
      display: 'flex',
      justifyContent: 'space-around',
      marginBottom: '48px',
    },
    '@media (max-width: 768px)': {
      filters: {
        flexDirection: 'column',
      },
    },
  }),
)(JobBoard);
